import React from 'react'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import ProjectCard from '../components/ProjectCard'


const Project = () => {
  return (
    <div>
        <Navbar/>
        <ProjectCard/>
        <Footer/>
    </div>
  )
}

export default Project